module.exports = __webpack_public_path__ + "static/media/DW6010.ffce8dd7.png";